import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CronsService } from '../crons.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';

@Component({
	selector: 'app-add-crons',
	templateUrl: './add-crons.component.html',
	styleUrls: ['./add-crons.component.scss'],
})
export class AddCronsComponent {
	// general error
	errorTitle: string = environment.config.customNotifications.headers.error;
	errorIcon: string = environment.config.customNotifications.icons.error;
	errorType: string = environment.config.customNotifications.icons.error;
	helper = helper;

	token!: string;
	isLoading = false;

	activeOptions = [
		{ label: 'Da', value: 1 },
		{ label: 'Nu', value: 0 },
	];

	form: FormGroup = new FormGroup({
		name: new FormControl('', Validators.required),
		path: new FormControl('', Validators.required),
		slug: new FormControl('', Validators.required),
		interval: new FormControl('', Validators.required),
	});

	constructor(
		private dialogRef: MatDialogRef<AddCronsComponent>,
		private cronsService: CronsService,
		private notificationService: NotificationService,
		private authService: AuthService
	) {
		this.processToken();
	}

	closeDialog() {
		this.dialogRef?.close({
			success: false,
		});
	}

	processToken() {
		const tokenObj = this.authService.returnTokenUser();
		tokenObj.then((token) => {
			this.token = token;
			this.cronsService.setToken(token);
		});
	}

	submitForm() {
		this.isLoading = true;

		const cron = {
			name: this.form.get('name')?.value,
			path: this.form.get('path')?.value,
			slug: this.form.get('slug')?.value,
			interval: this.form.get('interval')?.value,
		};
		this.cronsService
			.addCrons(cron)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe({
				next: (res) => {
					this.dialogRef.close({ success: true });
				},
				error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
				},
			});
	}
}
